import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TiDeleteOutline, TiInfoOutline } from 'react-icons/ti';
import { FaCircleInfo } from 'react-icons/fa6';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { toast } from 'react-toastify';

import Confirmation from '../Confirmation';
import Toggle from '../Toggle';

import './BuildForm.scss';
import { StorageEnum } from '../../utils/enumerators/Storage.enum';

export default function BuildForm({ tags, branches, clients, onChangeTarget, onSubmit, sequential, android, version, fastfileExists }) {
	const [workflows, setWorkflows] = useState([]);
	const [clientSearch, setClientSearch] = useState('');
	const [selectedTag, setSelectedTag] = useState(undefined);
	const [selectedBranch, setSelectedBranch] = useState(undefined);
	const [selectedClients, setSelectedClients] = useState([]);
	const [selectedWorkflow, setSelectedWorkflow] = useState('');
	const [sequentialEnable, setSequentialEnable] = useState(false);
	const [selectedSequential, setSelectedSequential] = useState(sequential);
	const [releaseNotes, setReleaseNotes] = useState('');
	const [automaticRelease, setAutomaticRelease] = useState(true);
	const [skipDeploy, setSkipDeploy] = useState(false);

	function onChangeClients(e) {
		let enterEvent = e.key == 'Enter';

		var isInputEvent = e.nativeEvent.inputType == 'insertText';

		const value = e.target.value;

		let matchCount = 0;

		clients.forEach((client) => {
			if (client.includes(value)) {
				matchCount++;
			}
		});

		setClientSearch(value);

		if (!clients.includes(value) || selectedClients.includes(value) || (isInputEvent && matchCount >= 2 && !enterEvent)) {
			return;
		}

		const newClients = selectedClients.concat(value);

		setSelectedClients(newClients);

		setClientSearch('');
	}

	function checkReleaseNotes() {
		if ((fastfileExists && android) || (selectedWorkflow && selectedWorkflow.endsWith('-new'))) {
			const cacheKey = `${StorageEnum.RELEASE_NOTES}-${selectedTag || selectedBranch}-${android ? 'android' : 'ios'}`;

			setReleaseNotes(localStorage.getItem(cacheKey));
		} else {
			setReleaseNotes('');
		}
	}

	useEffect(() => {
		setSelectedClients([]);
		setSelectedSequential('');
		setSequentialEnable(false);
	}, [selectedTag, selectedBranch]);

	useEffect(() => {
		setSelectedSequential(sequential);
	}, [sequential]);

	useEffect(() => {
		let allWorkflows = ['ios-app-store-new', 'ios-app-store', 'ios-export-release', 'ios-export-test'];

		if (fastfileExists) {
			setWorkflows(allWorkflows);
		} else {

			allWorkflows = allWorkflows.filter((x) => x != 'ios-app-store-new')

			setWorkflows(allWorkflows);
		}

		setSelectedWorkflow(allWorkflows[0]);

		checkReleaseNotes();
	}, [fastfileExists]);

	useEffect(() => {
		checkReleaseNotes();
	}, [selectedWorkflow]);

	useEffect(() => {
		// Android pode emoji
		if (android) {
			return;
		}

		if (hasEmoji(releaseNotes)) {
			// Remove emojis
			setReleaseNotes(releaseNotes.replace(/\p{Extended_Pictographic}/gu, ''));
		}
	}, [releaseNotes]);

	function hasEmoji(str) {
		const emojiRegex = /\p{Extended_Pictographic}/u;
		return emojiRegex.test(str);
	}

	return (
		<>
			<form id="formBuild">
				{!selectedBranch && (
					<div className="field">
						<label htmlFor="tags">TAG: </label>
						<select
							name="tags"
							id="tags"
							form="formBuild"
							value={selectedTag}
							title={selectedTag}
							onChange={(ev) => {
								onChangeTarget(ev.target.value);
								setSelectedTag(ev.target.value);
							}}>
							<option />
							{tags.map((tag, index) => (
								<option
									key={`tag-${index}`}
									value={tag.name}>
									{tag.name}
								</option>
							))}
						</select>
					</div>
				)}

				{!selectedTag && (
					<div className="field">
						<label htmlFor="tags">BRANCH: </label>
						<select
							name="branches"
							id="branches"
							form="formBuild"
							value={selectedBranch}
							title={selectedBranch}
							onChange={(ev) => {
								onChangeTarget(ev.target.value);
								setSelectedBranch(ev.target.value);
							}}>
							<option />
							{branches.map((branch, index) => (
								<option
									key={`branch-${index}`}
									value={branch.name}>
									{branch.name}
								</option>
							))}
						</select>
					</div>
				)}

				{clients.length > 0 && (
					<div className="field">
						<label htmlFor="clients">CLIENTE: </label>

						<input
							type="search"
							className="clients"
							list="clients"
							placeholder="Pesquise ou selecione..."
							value={clientSearch}
							onInput={(ev) => onChangeClients(ev)}
							onKeyPress={(ev) => onChangeClients(ev)}></input>

						<datalist
							multiple
							name="clients"
							id="clients"
							form="formBuild"
							value={selectedClients}>
							{clients.map((client, index) => (
								<option
									key={`client-${index}`}
									value={client}>
									{client}
								</option>
							))}
						</datalist>
					</div>
				)}

				{selectedClients.length > 0 && (
					<>
						{!android && (
							<div className="field">
								<label htmlFor="workflows">WORKFLOW: </label>
								<select
									name="workflows"
									id="workflows"
									form="formBuild"
									value={selectedWorkflow}
									onChange={(ev) => setSelectedWorkflow(ev.target.value)}>
									{workflows.map((workflow, index) => (
										<option
											key={`workflow-${index}`}
											value={workflow}>
											{workflow}  
										</option>
									))}
								</select> 
							</div>
						)}

						{(skipDeploy || !fastfileExists) && (
							<div className="field">
								<label htmlFor="sequential">SEQUENCIAL: </label>
								<Toggle onChange={setSequentialEnable} />
								<input
									ïd="sequential"
									disabled={!sequentialEnable}
									value={selectedSequential}
									onChange={(ev) => setSelectedSequential(ev.target.value)}
								/>
							</div>
						)}

						{fastfileExists && (android || (selectedWorkflow || '').endsWith('-new')) && (
							<>
								{!skipDeploy && (
									<div className={`field`}>
										<FaCircleInfo
											title="Define se irá distribuir a atualização automaticamente após revisão."
											className="info"
											size={18}
										/>
										<label htmlFor="automatic_release">LANÇAMENTO AUTOMÁTICO:</label>
										<Toggle
											value={automaticRelease}
											onChange={setAutomaticRelease}
										/>
									</div>
								)}

								{android && (
									<div className="field">
										<FaCircleInfo
											title="Define se irá apenas gerar build, sem fazer nenhum deploy para as lojas."
											className="info"
											size={18}
										/>
										<label htmlFor="just_build">APENAS BUILD (.APK e .AAB):</label>
										<Toggle
											value={skipDeploy}
											onChange={(checked) => {
												if (checked) {
													setAutomaticRelease(false);
												}

												setSkipDeploy(checked);
											}}
										/>
									</div>
								)}
							</>
						)}

						<div className="selecteds">
							{selectedClients.map((client) => (
								<div
									key={`selected-container-${client}`}
									className="selected">
									<TiDeleteOutline
										key={`remove-selected-${client}`}
										title={`Remover ${client} da lista`}
										onClick={() => {
											setSelectedClients(selectedClients.filter((x) => !x.includes(client)));
										}}
									/>

									<span key={`selected-${client}`}>{client}</span>
								</div>
							))}
						</div>

						{!skipDeploy && fastfileExists && (android || (selectedWorkflow || '').endsWith('-new')) && (
							<>
								<div className={`release-notes`}>
									<label htmlFor="release-notes">Notas da versão: </label>

									<div className="text-area-container">
										<textarea
											placeholder="Insira aqui as notas da versão..."
											ïd="release-notes"
											value={releaseNotes}
											onChange={(ev) => setReleaseNotes(ev.target.value)}
										/>
									</div>
								</div>
							</>
						)}

						<button
							type="button"
							onClick={() => {
								if (!skipDeploy && fastfileExists && (android || (selectedWorkflow || '').endsWith('-new'))) {
									if (releaseNotes.length < 100) {
										toast.warning('As notas da versão devem ter no mínimo 100 caracteres.');
										return;
									}

									if (!android && hasEmoji(releaseNotes)) {
										toast.warning('As notas da versão não podem ter emojis no iOS.');
										return;
									}
								}
								withReactContent(Swal)
									.fire({
										icon: 'info',
										title: 'Confirmação',
										denyButtonText: 'Cancelar',
										confirmButtonText: 'Confirmar',
										showDenyButton: true,
										html: (
											<Confirmation
												selectedClients={selectedClients}
												selectedWorkflow={selectedWorkflow}
												target={selectedTag || selectedBranch}
												selectedSequential={sequentialEnable ? selectedSequential : null}
												android={android}
												releaseNotes={fastfileExists ? releaseNotes : ''}
												automaticRelease={fastfileExists ? automaticRelease : false}
												skipDeploy={fastfileExists ? skipDeploy : true}
											/>
										),
									})
									.then((response) => {
										if (response.isConfirmed) {
											const automaticDeploy = fastfileExists && (android || (selectedWorkflow || '').endsWith('-new'));

											onSubmit(
												selectedClients,
												selectedWorkflow,
												sequentialEnable ? selectedSequential : null,
												automaticDeploy ? releaseNotes : '',
												selectedTag || selectedBranch,
												automaticDeploy ? automaticRelease : false,
												skipDeploy,
											);
										}
									});
							}}>
							ENVIAR BUILD
						</button>
					</>
				)}
			</form>
		</>
	);
}

BuildForm.propTypes = {
	tags: PropTypes.array,
	clients: PropTypes.array,
	android: PropTypes.bool,
};
